import { createBrowserRouter } from 'react-router-dom';
import { AuthLayout } from '@features/user/auth/layout';
import HomePage from '@pages/user/Home';
import { DashBoardPage } from '@pages/user/Dashboard';
import { SignInPage } from '@pages/user/SignIn';
import { SignUpPage } from '@pages/user/SignUp';
import { ForgotPassword } from '@pages/user/ForgotPassword';
import { ResetPassword } from '@pages/user/ResetPassword';
import { CheckoutLayout } from '@features/user/checkout/layout';
import { UserLayout } from '@features/core/ui/layout/user';
import { AdminAuthLayout, AdminLayout } from '@features/core/ui/layout/admin';
import { PayoutRequestPage } from '@pages/user/PayoutRequest.tsx';
import { LeaderboardPage } from '@pages/user/Leaderboard.tsx';
import { KnowledgeBasePage } from '@pages/user/KnowledgeBase.tsx';
import { DownloadsPage } from '@pages/user/Downloads.tsx';
import { DashBoardAdminPage } from '@pages/admin/DashBoardAdminPage.tsx';
import { StatusPage } from '@pages/admin/Status.tsx';
// import { Emails } from '@pages/admin/Emails.tsx';
import { EmailDetail } from '@pages/admin/EmailDetail.tsx';
import { TradingPlatforms } from '@pages/admin/TradingPlatforms.tsx';
import { TradingPlatformDetail } from '@pages/admin/TradingPlatformDetail.tsx';
import { PayoutRequestsAdmin } from '@pages/admin/PayoutRequests.tsx';
import { InstrumentsPage } from '@pages/admin/InstrumentsPage.tsx';
import { Settings } from '@pages/admin/Settings.tsx';
import { SettingEdits } from '@pages/admin/SettingEdits.tsx';
import { BillingPage } from '@pages/user/BillingPage.tsx';
import { PackagesPage } from '@pages/admin/PackagesPage.tsx';
import { PackagesEditPage } from '@pages/admin/PackagesEditPage.tsx';
import { CouponsPage } from '@pages/admin/CouponsPage.tsx';
import { CouponEditPage } from '@pages/admin/CouponEditPage.tsx';
import { ProductsAddonsPage } from '@pages/admin/ProductsAddonsPage.tsx';
import { ProductEdit } from '@pages/admin/ProductEdit.tsx';
import { AddonEdit } from '@pages/admin/AddonEdit.tsx';
import { ReportsPage } from '@pages/admin/reports/ReportsPage.tsx';
import { AdminSignInPage } from '@pages/admin/AdminSignInPage.tsx';
import { PasswordResetOtp } from '@pages/admin/PasswordResetOtp.tsx';
import { AdminResetPassword } from '@pages/admin/AdminResetPassword.tsx';
import { UserDetailPage } from '@pages/admin/UserDetailPage.tsx';
import { AdminForgotPassword } from '@pages/admin/AdminForgotPassword.tsx';
import { ResetEdit } from '@pages/admin/ResetEdit.tsx';
import { MarketDataEdit } from '@pages/admin/MarketDataEdit.tsx';
import { FeeSettingsPage } from '@pages/admin/FeeSettingsPage.tsx';
import { CreateDomesticSalesTaxPage } from '@pages/admin/CreateDomesticSalesTaxPage.tsx';
import { CreateInternationalSalesTaxPage } from '@pages/admin/CreateInternationalSalesTaxPage.tsx';
import { UsersPage } from '@pages/admin/UsersPage';
import { BrowseUsersPage } from '@pages/admin/BrowseUsersPage';
import { BrowseUserDetailPage } from '@pages/admin/BrowseUserDetailPage';
import { UserDemographicsPage } from '@pages/admin/UserDemographicsPage';
import { AbandonedCartPage } from '@pages/admin/AbandonedCartPage';
import { ProfilePage } from '@pages/user/Profile';
import { AffiliatesPayoutsPage } from '@src/pages/user/AffiliatesPayouts';
import { RenewLayout } from '@features/user/renew/layout';
import { RenewSelectAccountPage } from '@pages/user/renew/RenewSelectAccount.tsx';
import { RenewReviewCheckoutPage } from '@pages/user/renew/RenewReviewCheckoutPage.tsx';
import { TRole } from '@src/types';
import RestrictedRoute from '@features/ui/components/restricted-route.tsx';
import { CreatePaAccountPage } from '@pages/user/CreatePaAccountPage.tsx';
import { CreatePaAccountCheckoutPage } from '@pages/user/createPaAccountCheckout/CreatePaAccountCheckoutPage.tsx';
import { SelectAccountTypePageV2 } from '@pages/user/checkout/v2/AccountType.tsx';
import { KnowledgeBasePage as KnowledgeBasePageAdmin } from '@pages/admin/KnowledgeBasePage.tsx';
import { TermsAndConditionsPage } from '@pages/admin/TermsAndConditionsPage';
import { TermsAndConditionsEdit } from '@pages/admin/TermsAndConditionsEdit';
import { MarketDataPage } from '@pages/user/marketData';
import { MarketDataCheckoutPage } from '@pages/user/marketData/MarketDataCheckoutPage';
import { MintSettingsPage } from '@pages/admin/MintSettingsPage';

import { SelectPlatformPageV2 } from './pages/user/checkout/v2/SelectPlatform';
import { SelectAccountPage } from './pages/user/checkout/v2/SelectAccount';
import { AddOns } from './pages/user/checkout/v2/AddOns';
import { OrderSummary } from './pages/user/checkout/v2/OrderSummary';
import { Congratulations } from './pages/user/checkout/v2/Congratulations';
import { KnowledgeBaseEdit } from './pages/admin/KnowledgeBaseEdit';
import { AffiliatesPayoutMethodsPage } from './pages/user/AffiliatesPayoutMethodsPage';
import { AffiliatesBannerAndLinksPage } from './pages/user/AffiliatesBannerAndLinksPage';
import { AffiliateAccountLinksPage } from './pages/user/AffiliateAccountLinksPage';
import { AffiliateCheckoutPage } from './pages/user/checkout/AffiliateCheckout';
import { AffiliateSelectPlatform } from './pages/user/checkout/affiliate/SelectPlatform';
import { AffiliateAddOns } from './pages/user/checkout/affiliate/SelectAddons';
import { AffiliateOrderSummary } from './pages/user/checkout/affiliate/OrderSummay';

export const routes = createBrowserRouter([
  {
    path: 'create-pa-account/:leeloo_user_id/:leeloo_account_id',
    element: <CreatePaAccountPage />,
  },
  {
    path: '/',
    element: (
      <RestrictedRoute
        authRedirectTo={'/signin'}
        deniedRoles={[TRole.User]}
        redirectTo={'/admin'}
      >
        {({ me }) => <UserLayout me={me} />}
      </RestrictedRoute>
    ),
    children: [
      {
        index: true,
        path: '',
        element: <DashBoardPage />,
      },
      {
        path: 'payout-request',
        element: <PayoutRequestPage />,
      },
      {
        path: 'leaderboard',
        element: <LeaderboardPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'affiliates/payouts',
        element: <AffiliatesPayoutsPage />,
      },
      {
        path: 'affiliates/payout-method',
        element: <AffiliatesPayoutMethodsPage />,
      },
      {
        path: 'affiliates/banner-and-links',
        element: <AffiliatesBannerAndLinksPage />,
      },
      {
        path: 'affiliates/account-links',
        element: <AffiliateAccountLinksPage />,
      },
      {
        path: 'knowledge-base',
        element: <KnowledgeBasePage />,
      },
      {
        path: 'download',
        element: <DownloadsPage />,
      },
      {
        path: 'billing',
        element: <BillingPage />,
      },
      {
        path: 'market-data',
        element: <MarketDataPage />,
      },
      {
        path: 'market-data/checkout',
        element: <MarketDataCheckoutPage />,
      },
    ],
  },

  {
    path: '/',
    element: <CheckoutLayout />,
    children: [
      {
        path: 'select-trading-platform',
        // element: <SelectPlatformPage />,
        element: <SelectPlatformPageV2 />,
      },
      {
        path: 'select-trading-account-type',
        // element: <SelectPlatformPage />,
        element: <SelectAccountTypePageV2 />,
      },
      {
        path: 'select-account',
        element: <SelectAccountPage />,
      },
      {
        path: 'add-ons',
        element: <AddOns />,
      },
      {
        path: 'congratulations',
        element: <Congratulations />,
      },
      {
        path: 'review-checkout',
        // element: <ReviewCheckoutPage />,
        element: <OrderSummary />,
      },
    ],
  },
  {
    path: '/checkout/affiliate',
    element: <AffiliateCheckoutPage />,
  },
  {
    path: '/checkout/affiliate/select-trading-platform',
    element: <AffiliateSelectPlatform />,
  },
  {
    path: '/checkout/affiliate/addons',
    element: <AffiliateAddOns />,
  },
  {
    path: '/checkout/affiliate/review-checkout',
    element: <AffiliateOrderSummary />,
  },
  {
    path: '/',
    element: <RenewLayout />,
    children: [
      {
        path: '/renew/select-account',
        element: <RenewSelectAccountPage />,
      },
      {
        path: '/renew/review-checkout',
        element: <RenewReviewCheckoutPage />,
      },
    ],
  },
  {
    path: '/',
    element: <RenewLayout isCreatePaAccount />,
    children: [
      {
        path: '/create-pa-account-checkout/:sub_type/:leeloo_user_id/:leeloo_account_id',
        element: <CreatePaAccountCheckoutPage />,
      },
    ],
  },
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      {
        path: 'signin',
        element: <SignInPage />,
      },
      {
        path: 'signup',
        element: <SignUpPage />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: '/admin',
    element: (
      <RestrictedRoute deniedRoles={[TRole.Admin]}>
        <AdminLayout />
      </RestrictedRoute>
    ),
    children: [
      {
        index: true,
        path: '',
        element: <HomePage />,
      },
      {
        path: 'dashboard',
        element: <DashBoardAdminPage />,
      },
      {
        path: 'status',
        element: <StatusPage />,
      },
      {
        path: 'users/:id',
        element: <UserDetailPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'browse-users',
        element: <BrowseUsersPage />,
      },
      {
        path: 'browse-users/:id',
        element: <BrowseUserDetailPage />,
      },
      {
        path: 'user-demographics',
        element: <UserDemographicsPage />,
      },
      {
        path: 'abandoned-cart',
        element: <AbandonedCartPage />,
      },
      // {
      //   path: 'emails',
      //   element: <Emails />,
      // },
      {
        path: 'emails/:id',
        element: <EmailDetail isEdit />,
      },
      {
        path: 'emails/create',
        element: <EmailDetail />,
      },
      {
        path: 'trading-platforms',
        element: <TradingPlatforms />,
      },
      {
        path: 'trading-platforms/:id',
        element: <TradingPlatformDetail isEdit />,
      },
      {
        path: 'trading-platforms/create',
        element: <TradingPlatformDetail />,
      },
      {
        path: 'payout-request',
        element: <PayoutRequestsAdmin />,
      },
      {
        path: 'instruments',
        element: <InstrumentsPage />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'settings-user/:id',
        element: <SettingEdits />,
      },
      {
        path: 'settings-user/create',
        element: <SettingEdits isCreate />,
      },
      {
        path: 'packages',
        element: <PackagesPage />,
      },
      {
        path: 'packages/:id',
        element: <PackagesEditPage />,
      },
      {
        path: 'coupons',
        element: <CouponsPage />,
      },
      {
        path: 'coupons/create',
        element: <CouponEditPage />,
      },
      {
        path: 'coupons/:id',
        element: <CouponEditPage />,
      },
      {
        path: 'products-addons',
        element: <ProductsAddonsPage />,
      },
      {
        path: 'products-addons/product/:id',
        element: <ProductEdit isEdit />,
      },
      {
        path: 'products-addons/product/create',
        element: <ProductEdit />,
      },
      {
        path: 'products-addons/addon/:id',
        element: <AddonEdit />,
      },
      {
        path: 'products-addons/reset/:id',
        element: <ResetEdit />,
      },
      {
        path: 'products-addons/market-data/:id',
        element: <MarketDataEdit />,
      },
      {
        path: 'reports',
        element: <ReportsPage />,
      },
      {
        path: 'fee-settings',
        element: <FeeSettingsPage />,
      },
      {
        path: 'fee-settings/domestic',
        element: <CreateDomesticSalesTaxPage />,
      },
      {
        path: 'fee-settings/international',
        element: <CreateInternationalSalesTaxPage />,
      },
      {
        path: 'knowledge-base',
        element: <KnowledgeBasePageAdmin />,
      },
      {
        path: 'knowledge-base/:id',
        element: <KnowledgeBaseEdit />,
      },
      {
        path: 'terms-and-conditions',
        element: <TermsAndConditionsPage />,
      },
      {
        path: 'mint-settings',
        element: <MintSettingsPage />,
      },
      {
        path: 'terms-and-conditions/:id',
        element: <TermsAndConditionsEdit />,
      },
    ],
  },
  {
    path: '/admin',
    element: <AdminAuthLayout />,
    children: [
      {
        path: 'signin',
        element: <AdminSignInPage />,
      },
      {
        path: 'forgot-password',
        element: <AdminForgotPassword />,
      },
      {
        path: 'forgot-password-otp',
        element: <PasswordResetOtp />,
      },
      {
        path: 'reset-password',
        element: <AdminResetPassword />,
      },
    ],
  },
]);
